import { SidebarProvider } from "@/components/ui/sidebar";
import Header from "@/components/Header";
import AppSidebar from "@/components/Sidebar";
import SharedContentLayout from "@/components/SharedContentLayout";

const Index = () => {
  console.log("🏠 Index: Rendering with shared layout");
  
  return (
    <SidebarProvider>
      <div className="h-screen flex w-full bg-background">
        <AppSidebar />
        <div className="flex-1 flex flex-col">
          <Header />
          <main className="flex-1 px-4 overflow-y-auto">
            <SharedContentLayout />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Index;
